type ExclusionInput = {
  noHazardsNotReporting?: boolean | null;
  physicalHazards?: string[] | null;
  healthHazards?: string[] | null;
};

export type ChemicalExclusionWarning = "hazards_present";

export const CHEMICAL_EXCLUSION_HAZARDS_TOOLTIP =
  "The chemical catalog entry is marked as excluded from Tier II reporting, but the chemical has hazards listed.";

/**
 * Returns a non-null warning code when a chemical is marked as excluded from
 * Tier II reporting (`noHazardsNotReporting=true`) but its hazards arrays
 * indicate the exclusion may be a mistake. Shared so every input surface
 * agrees on what counts as a suspicious exclusion.
 */
export function chemicalExclusionWarning(
  chemical: ExclusionInput
): ChemicalExclusionWarning | null {
  if (!chemical.noHazardsNotReporting) return null;
  const hasPhysical = (chemical.physicalHazards?.length ?? 0) > 0;
  const hasHealth = (chemical.healthHazards?.length ?? 0) > 0;
  if (hasPhysical || hasHealth) return "hazards_present";
  return null;
}
